import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/store/UIStore';
import SendFeedbackRootPanelContent from './SendFeedbackRootPanelContent.tsx';
import { ReportIssuePanelContent, SuggestIdeaPanelContent } from './SendFeedbackPanelContent.tsx';
import TopLevelSidePanel from './TopLevelSidePanel.tsx';

const SendFeedbackSidePanel = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState<'root' | 'issue' | 'idea'>('root');

  const activeSidePanel = useUIStore((state) => state.showSendFeedbackToplevelSidePanel);
  const setActiveSidePanel = useUIStore((state) => state.setShowSendFeedbackToplevelSidePanel);

  const handleClose = () => {
    setStep('root');
    setActiveSidePanel(false);
  };

  const handleBack = step !== 'root' ? () => setStep('root') : undefined;

  const title = (() => {
    switch (step) {
      case 'issue':
        return t('feedback.reportIssue');
      case 'idea':
        return t('feedback.suggestIdea');
      default:
        return t('feedback.sendFeedback');
    }
  })();

  return (
    <TopLevelSidePanel show={activeSidePanel} onClose={handleClose} onBack={handleBack} title={title}>
      {step === 'root' && <SendFeedbackRootPanelContent onSelect={setStep} />}
      {step === 'issue' && <ReportIssuePanelContent onPostSubmit={handleClose} />}
      {step === 'idea' && <SuggestIdeaPanelContent onPostSubmit={handleClose} />}
    </TopLevelSidePanel>
  );
};

export default SendFeedbackSidePanel;
